export class Alert {
    constructor(public id: string, public type: string, public msg: string) {
    }
}
